module.exports = __webpack_public_path__ + "img/proyecto_11.021eda72.png";